import React, { useState } from 'react'
import Measure from 'react-measure'
import Icon from 'blocks.simple/icon/icon'
import { cn } from 'ethcss'
import styles from './notification.jcss'
import { grid, item } from '../../theme'
import type { NotificationBounds, NotificationDefaultProps, NotificationProps } from './notification.types'

const Notification = (p_: NotificationProps) => {
    const initialBounds: NotificationBounds = {
        height: 300,
    }
    const [bounds, setBounds] = useState<NotificationBounds>(initialBounds)

    return (
        <Measure
            bounds
            onResize={function ({ bounds }) {
                if (bounds) {
                    setBounds({ height: bounds.height })
                }
            }}
        >
            {({ measureRef }) => (
                <div
                    ref={measureRef}
                    className={cn(styles.notification, { [item.hidden]: !p_.show })}
                    style={{
                        ...item[p_.color],
                        zIndex: p_.color === 'errorLight' ? 11100 : 1800,
                        [p_.position]: p_.show ? 0 : -bounds.height,
                    }}
                >
                    {p_.showIcon && <Icon {...p_.icon} containerClass={cn(grid.mr_mini)} />}
                    {p_.children}
                </div>
            )}
        </Measure>
    )
}

const defaultProps: NotificationDefaultProps = {
    icon: {
        type: 'attention',
        color: 'white',
        size: 20,
    },
    showIcon: true,
    show: false,
    color: 'errorLight',
    position: 'bottom',
}

Notification.defaultProps = defaultProps

export default Notification
